import React from "react";
import PropTypes from "prop-types";
import "./Scanner.css";
import ErrorDisplay from "./components/ErrorDisplay";
import useScanner from "./hooks/useScanner";

const Scanner = ({ user, onStopScan, setUniqueKey, setUserID, onCancel }) => {
  const {
    message,
    instructions,
    showRetry,
    startScanner,
  } = useScanner({ user, onStopScan, setUniqueKey, setUserID });

  return (
    <div className="scanner-wrapper">
      <div className="scanner-container">
        <h2 className="scanner-heading">QR Code Scanner</h2>

        <ErrorDisplay
          message={message}
          instructions={instructions}
          showRetry={showRetry}
          onRetry={startScanner}
        />

        <div id="reader" className="qr-reader" />
      </div>

      {!message && (
        <div className="scanner-back-button">
          <button
            onClick={onCancel}
            style={{
              width: "100%",
              backgroundColor: "#757575",
              borderColor: "#757575"
            }}
          >
            Back to Dashboard
          </button>
        </div>
      )}
    </div>
  );
};

Scanner.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
  }),
  onStopScan: PropTypes.func,
  setUniqueKey: PropTypes.func,
  setUserID: PropTypes.func,
  onCancel: PropTypes.func,
};

export default Scanner;
